import ControlledInput from './ControlledInput.jsx';
import ControlledSelect from './ControlledSelect.jsx';
import {
  isForeignCityValid,
  isRequiredSelect
} from '@@viewHelpers/validations';

export const CITY_FIELD = 'customer.addresses.0.city';

const ControlledCity = ({
  form,
  cities = [],
  isDisplayed = true,
  isRequired = false,
  disabled = false,
  displayFrenchFields = true,
  displayForeignFields = false,
  name,
  label,
  cityTestId,
  foreignCityTestId
}) => {
  if (!isDisplayed) {
    return null;
  }

  return (
    <>
      <ControlledSelect
        name={name}
        label={label}
        form={form}
        options={cities}
        rules={isRequiredSelect(cities, isRequired)}
        disabled={disabled}
        data-testid={cityTestId}
        isDisplayed={displayFrenchFields}
      />
      <ControlledInput
        name={name}
        label={label}
        form={form}
        rules={isForeignCityValid(isRequired)}
        data-testid={foreignCityTestId}
        isDisplayed={displayForeignFields}
      />
    </>
  );
};

export default ControlledCity;
